// extracted by mini-css-extract-plugin
export default {"icon":"_92247dee1304c3fc","validationInfoWrapper":"_9301cea4300f366d"};